<template>
<div>
  <div v-if="!validation">
    <p class="has-text-danger">No Validation Found.</p>
  </div>
  <div v-else>
    <p class="has-text-weight-bold" v-html="getClassName(validation)"></p>
    {{ validation.rules }}
    <p v-if="!Object.keys(validation.rules).length" class="has-text-danger">No validation rules found.</p>
  </div>
</div>  
</template>
<script>
import { mapGetters } from 'vuex'
import { last } from 'lodash'

export default {

  methods: {
    getRules(rules) {
      if(rules instanceof Array) {
        return this.buildArrayString(rules)
      }
      
      if(rules instanceof Object) {
        let parsedRules = []
        for(var key in rules) {
          parsedRules[key] = rules[key]
        }
        console.log(parsedRules)
        return parsedRules
      }
      
      return `<span class="code-string">${rules}</span>`
    },
    buildArrayString(rules) {
      let string = rules.reduce((string, rule) => {
        if(!rule.length) return string
        return string + `<span class="code-string">${rule}</span>, `
      }, '[ ')

      return string + ' ]'
    },
    getClassName(validation) {
      if(!validation.form_request && validation.rules.length) return 'Controller Validation'
      let parts = validation.form_request.split('\\')
      return parts.length ? `<span class="class-name">${last(parts)}</span>` : 'Controller Validation'
    },
    rulesAreArray(rules) {
      return rules instanceof Array
    },
    rulesAreString(rules) {
      return rules instanceof String
    },
    rulesAreObject(rules) {
      return rules instanceof Object
    }
  },

  computed: {
    ...mapGetters('route', [
      'route'
    ]),
    validation() {
      return this.route.request_validation
    }
  }

}
</script>